import { useEffect, useState } from 'react';
import axios from 'axios';
import './Nature.scss';
import InnerNav from '../../../../../components/InnerNav/InnerNav';
import Footer from '../../../../../components/Footer/Footer';
import { useFormData } from "../../ContextData/ContextData"; // assuming userData is available

const Nature = () => {
  const { userData } = useFormData(); // { year, month, day, hour, minute, name }
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPersonality = async () => {
      try {
        const response = await axios.get(
          "https://core-c343.onrender.com/api/predict-personality",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
              location: userData.city,
              name: userData.name,
            },
          }
        );
        setData(response.data);
      } catch (err) {
        setError("Failed to load personality data.");
      } finally {
        setLoading(false);
      }
    };

    fetchPersonality();
  }, []);

  if (loading) {
    return <div className="chl-container"><p>Loading...</p></div>;
  }

  if (error) {
    return <div className="chl-container"><p>{error}</p></div>;
  }

  if (!data) {
    return <div className="chl-container"><p>No data available.</p></div>;
  }

  // Convert API response sections into array format
  const sections = [
    { subTitle: "CHARACTER", content: data.sections.CHARACTER },
    { subTitle: "HAPPINESS AND FULFILLMENT", content: data.sections.HAPPINESS_AND_FULFILLMENT },
    { subTitle: "LIFE STYLE", content: data.sections.LIFE_STYLE }
  ];

  return (
    <div className="chl-container">
      <InnerNav />
      <h2>{data.aspect}</h2>
      <div className="chl-cards">
        {sections.map((section, index) => (
          <div key={index} className="chl-card">
            <h3>{section.subTitle}</h3>
            <p>{section.content}</p>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default Nature;
